import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Wizard from './Wizard'
import CPNameStep from './CPNameStep'
import CPTypeStep from './CPTypeStep'
import { ProjectProvider } from './NewProjectContext'
import CPCreateProjectStep from './CPCreateProjectStep'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .modal-content {
    background: #1a1a1a;
    border: none;
  }

  .modal-header {
    background: ${() => `linear-gradient(${Math.floor(Math.random() * 360)}deg, #402563, #114ee0)`};
    border-bottom: none;
    padding: 1.25rem 1.5rem;

    .modal-title {
      color: white;
      font-weight: 600;
      font-size: 1.25rem;
    }

    .btn-danger {
      background: transparent;
      border: 1px solid rgba(255, 255, 255, 0.2);
      padding: 0.5rem 1rem;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.3);
      }
    }
  }

  .modal-body {
    padding: 0;
    background: #2a2a2a;
  }
`

interface CreateProjectModalProps {
  show: boolean
  onHide: () => void
}

const CPWizard: React.FC<CreateProjectModalProps> = ({ show, onHide }) => {
  const handleCancel = () => {
    onHide()
  }

  return (
    <StyledModal show={show} onHide={onHide} centered size="xl" className="create-project-modal">
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <Modal.Title>Create New Project</Modal.Title>
        <Button variant="danger" onClick={handleCancel}>
          Cancel
        </Button>
      </Modal.Header>
      <Modal.Body>
        <ProjectProvider>
          <Wizard
            steps={[
              {
                name: 'Project Type',
                component: CPTypeStep,
                title: 'Select your project type',
                validate: (context) => !!context.projectType,
              },
              {
                name: 'Name and Description',
                component: CPNameStep,
                title: 'Name and describe your project',
                validate: (context) =>
                  !!context.projectName &&
                  context.projectName.trim().length >= 3 &&
                  context.projectName.trim().length <= 50,
              },
              {
                name: 'Create Project',
                component: CPCreateProjectStep,
                title: 'Create your project',
                validate: (context) => !!context.projectName && !!context.projectType,
              },
            ]}
            stepProps={{ onHide }}
          />
        </ProjectProvider>
      </Modal.Body>
    </StyledModal>
  )
}

export default CPWizard
